export const CHAT_SPAWN_SIGN_IN_MESSAGE = "Sign in to spawn chat messages.";

function getDefaultAppContext() {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window.APP;
}

export function isChatSpawnAuthenticated(app = getDefaultAppContext()) {
  return Boolean(app?.hubChannel?.signedIn || app?.store?.state?.authUser?.id);
}

export function runChatSpawnWithConditionalSignIn(action, app = getDefaultAppContext()) {
  if (typeof action !== "function") {
    return undefined;
  }

  const performConditionalSignIn = app?.entryManager?.performConditionalSignIn;
  if (typeof performConditionalSignIn !== "function") {
    return action();
  }

  return performConditionalSignIn(() => isChatSpawnAuthenticated(app), action, CHAT_SPAWN_SIGN_IN_MESSAGE);
}
